import { of } from "rxjs";
import { actionPendingInventoryInfoReceived } from "../../pending-inventory/actionPendingInventoryInfo";
export var networkNoticePendingInventoryInfoHandler = function (action$, state$, deps) { return function (res) { return of(actionPendingInventoryInfoReceived(res)); }; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticePendingInventoryInfoHandler.ts
// module id = 2014
// module chunks = 3